<div class="table-helper">
    <ng-content></ng-content>
</div>